module.exports = {
      id: "file-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#file-usage",
      toString: function () {
        return this.url;
      }
    }